export default {
    linkList: {
        "companyLink": "Sobre nosotros",
        "termsOfService": "Condiciones de uso",
        "privacyPolicy": "Política de privacidad",
        "guaranteeOfRights": "Derechos sobre datos personales",
        "customerSupport": "ATENCIÓN AL CLIENTE",
        "cookiePolicy": "Política de cookies",
        "declarationOfSafety": "Seguridad・Declaración de seguridad",
        "youthProtectionPolicy": "Política de protección de menores",
        "communityPolicy": "Política de la comunidad",
        "operationPolicy": "Política de operaciones",
        "doNotSell": "No vender mis datos personales",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
        "reportRightsInfringement": "권리침해신고",
        "ncPrivacyCenter": "NC 프라이버시 센터",
        "commercialTransactions": "특정상거래법에 의거한 표기",
        "settlementFund": "자금결제법에 따른 표시",
        "serviceTerm": "서비스 이용약관",
    },
    footerWords: {
        "gameRelatedLaw": "Información adicional sobre las leyes de juegos",
        "brandInformation": "Datos de la empresa",
        "copyright": "Copyright",
        "channelingInfo": "NCSOFT es un intermediario que media entre el comercio electrónico de juegos dentro de plaync, y no es una parte comercial de dichas ventas.<br>Todas las obligaciones y responsabilidades asociadas con los juegos proporcionados recaen en la parte individual de comercio electrónico, y no somos responsables de los problemas relacionados con ellos.",
    },
    infoCS: {
        "businessInformation": "Ver datos de la empresa",
        "infoAddress": "Nombre de la empresa NCSOFT Corporation, CEO Kim Taek-Jin, Número de registro mercantil 144-85-04244, Registro de comercio en línea 2013-Gyeonggi Seongnam-1268",
        "mobile": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al cliente: +82 1566-7004. Fax: +82 02-2186-3499.",
        "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3554",
        "other": "Dirección: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, República de Corea. Atención al cliente: +82 1600-0020 (Juegos de PC), +82 1566-7004 (Juegos de móvil). Fax: +82 02-2186-3550 (Juegos de PC), +82 02-2186-3499 (Juegos de móvil).",
        "none": "",
        "infoEmail": "Correo electrónico",

        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(PC Game)/MobileCS@ncsoft.com/(Mobile Game)",
        "infoEmail-none": "",
    },
    infoJP: {
        "jpTitle": "Título",
        "jpGenre": "Género",
        "jpPrice": "Precio",
        "jpPriceValue": "Juego gratuito (contiene compras dentro de la aplicación)",
        "jpOs": "Sistema operativo compatible",
        "jpDevelopedBy": "Desarrollador/distribuidora",
        "jpReleaseDay": "Fecha de lanzamiento",
        "jpReleaseDayValue_LW": "4 de noviembre de 2021",
    },
    country: {
        "KR": "Corea, República de",
        "TW": "Taiwán",
        "RU": "Rusia",
        "MY": "Malasia",
        "SA": "Arabia Saudí",
        "SG": "Singapur",
        "AE": "Emiratos Árabes Unidos",
        "ID": "Indonesia",
        "JP": "Japón",
        "QA": "Catar",
        "TH": "Tailandia",
        "PH": "Filipinas",
        "HK": "Hong Kong",
        "UA": "Ucrania",
        "BY": "Bielorrusia",
        "LT": "Lituania",
        "PL": "Polonia",
        "GR": "Grecia",
        "IL": "Israel",
        "KW": "Kuwait",
        "AT": "Austria",
        "US": "Estados Unidos de América",
        "CA": "Canadá",
        "DE": "Alemania",
        "GB": "Reino Unido",
        "FR": "Francia",
        "BR": "Brasil",
        "IT": "Italia",
        "ES": "España",
        "CL": "Chile",
        "NO": "Noruega",
        "SE": "Suecia",
        "IE": "Irlanda",
        "PT": "Portugal",
        "FI": "Finlandia",
        "DK": "Dinamarca",
        "CH": "Suiza",
        "AR": "Argentina",
        "PE": "Perú",
        "MX": "México",
        "KZ": "Kazajistán",
        "UZ": "Uzbekistán",
        "AZ": "Azerbaiyán",
        "GE": "Georgia",
        "MD": "Moldavia",
        "AM": "Armenia",
        "MO": "Macao",
        "IN": "India",
        "PK": "Pakistán",
        "NL": "Países Bajos",
        "RO": "Rumanía",
        "AU": "Australia",
        "TR": "Turquía",
        "EC": "Ecuador",
        "CO": "Colombia",
        "ZA": "Sudáfrica",
        "EG": "Egipto",
        "NC": "Global",
    },
}
